import { useLocation } from 'react-router-dom';
import logo from '../shared/assets/sincro-logo.png';

const REASON_MESSAGES = {
  account_pending_approval: {
    text: 'Your access request is pending admin approval. You will receive an email when approved.',
    tone: 'warning',
  },
  account_deactivated: {
    text: 'This account has been deactivated. Contact an admin.',
    tone: 'error',
  },
  request_submitted: {
    text: 'Thanks — your access request has been submitted. An admin will review and approve.',
    tone: 'info',
  },
  google_profile_missing_email: {
    text: 'Google did not share an email address. Try again with a different account.',
    tone: 'error',
  },
  login_failed: {
    text: 'Sign-in failed. Try again or contact an admin.',
    tone: 'error',
  },
};

const TONE_CLASSES = {
  info: 'border-blue-300 bg-blue-100 text-blue-800',
  warning: 'border-yellow-300 bg-yellow-100 text-yellow-800',
  error: 'border-red-300 bg-red-100 text-red-800',
};

export function Login() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const reason = params.get('reason');
  const msg = reason ? REASON_MESSAGES[reason] || REASON_MESSAGES.login_failed : null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-sky-100 p-8">
      <div className="w-full max-w-md rounded-xl border border-sky-300 bg-white p-8 shadow-sm">
        <img src={logo} alt="Sincro" className="mx-auto mb-6 h-10" />
        <h1 className="mb-2 text-center text-xl font-semibold text-ink-900">
          Sincro Perfectmile
        </h1>
        <p className="mb-6 text-center text-sm text-ink-500">
          Sign in with your Easyship Google account to continue.
        </p>

        {msg && (
          <div
            role="alert"
            className={`mb-4 rounded-lg border p-3 text-sm ${TONE_CLASSES[msg.tone]}`}
          >
            {msg.text}
          </div>
        )}

        <a
          href="/auth/google"
          className="flex w-full items-center justify-center gap-2 rounded-md bg-green-400 px-6 py-3 text-sm font-semibold uppercase text-white transition-all hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
        >
          Sign in with Google
        </a>
      </div>
    </div>
  );
}
